import React, { useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import {
  Backdrop,
  Box,
  Button,
  Checkbox,
  Fade,
  FormControlLabel,
  Grid,
  Grid2,
  MenuItem,
  Modal,
  TextField,
  Typography,
} from "@mui/material";
import theme from "../theme";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch } from "react-redux";

import { setReduxSearchQuery } from "../redux/searchQuery";
import { dealTypes, roomsType, coinsType, propertyTypes } from "../reTypes";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "80%", md: "30%" },
  height: "90%",
  bgcolor: "background.paper",
  borderRadius: "20px",
  boxShadow: 24,
  p: 4,
  overflow: "auto",
  overflowX: "hidden",
  "&::-webkit-scrollbar": {
    display: "none",
  },
};

const SearchButton = () => {
  const [open, setOpen] = useState(false);
  const [checkedItems, setCheckedItems] = useState([]);
  const [searchQuery, setSearchQuery] = useState({});
  const dispatch = useDispatch();

  const handleCheckboxChange = (index) => {
    const id = formCheckBoxes[index].id;

    setCheckedItems((prev) =>
      prev.includes(index)
        ? prev.filter((item) => item !== index)
        : [...prev, index]
    );

    setSearchQuery((prev) => ({
      ...prev,
      [id]: prev[id] === 1 ? 0 : 1,
    }));
  };

  const handleFieldChange = (id, val) => {
    const numeric =
      id !== "state" && id !== "city" && id !== "address" && id !== "area"
        ? parseInt(val)
        : val;

    setSearchQuery((prev) => ({
      ...prev,
      [id]: numeric,
    }));
  };

  const handleSubmit = () => {
    dispatch(setReduxSearchQuery(searchQuery));
    setOpen(false);
  };

  const formCheckBoxes = [
    { label: "Furnitured", id: "furnished" },
    { label: "Pool", id: "pool" },
    { label: "Air Condition", id: "air_con" },
    { label: "Parking", id: "parking" },
    { label: "Storage", id: "storage" },
    { label: "Reconditioned", id: "reconditioned" },
    { label: "Elevators", id: "elevator" },
    { label: "Door Keeper", id: "door_keeper" },
    { label: "Access For Disabled", id: "disabled" },
  ];

  const formFields = [
    { label: "Deal Type:", items: dealTypes, rowGroup: 1, id: "deal_type" },
    {
      label: "Property Type:",
      items: propertyTypes,
      rowGroup: 1,
      id: "re_type",
    },

    { label: "Sqm - From:", items: [], rowGroup: 2, id: "square_from" },
    { label: "Sqm - To:", items: [], rowGroup: 2, id: "square_to" },

    { label: "State:", items: [], rowGroup: 2, id: "state" },
    { label: "City:", items: [], rowGroup: 2, id: "city" },

    { label: "Address:", items: [], rowGroup: 2, id: "address" },
    { label: "Area:", items: [], rowGroup: 2, id: "area" },

    { label: "Price - From:", items: [], rowGroup: 3, id: "price_from" },
    { label: "Price - To:", items: [], rowGroup: 3, id: "price_to" },
    { label: "Currency:", items: coinsType, rowGroup: 3, id: "coin" },

    {
      label: "Building Status:",
      items: [],
      rowGroup: 2,
      id: "building_status",
    },
    { label: "Building Age:", items: [], rowGroup: 2, id: "building_age" },

    { label: "Rooms - From:", items: roomsType, rowGroup: 2, id: "rooms_from" },
    { label: "Rooms - To:", items: roomsType, rowGroup: 2, id: "rooms_to" },

    { label: "Floors - From:", items: [], rowGroup: 2, id: "floor_from" },
    { label: "Floors - To:", items: [], rowGroup: 2, id: "floor_to" },

    {
      label: "Number Of Stories:",
      items: [],
      rowGroup: 1,
      id: "number_of_stories",
    },
  ];

  return (
    <Grid container sx={{ p: "10px" }} alignItems="center">
      <Grid item xs={12}>
        <Grid
          container
          alignItems="center"
          sx={{ cursor: "pointer" }}
          onClick={() => setOpen(true)}
        >
          <SearchIcon
            fontSize="large"
            sx={{ color: theme.palette.primary.main }}
          />
          <Typography fontWeight="bold" sx={{ pl: 1 }}>
            Search Property
          </Typography>
        </Grid>
      </Grid>

      <Modal open={open} onClose={() => setOpen(false)} closeAfterTransition>
        <Fade in={open}>
          <Box sx={style}>
            <Grid container justifyContent="space-between" alignItems="center">
              <Typography variant="h6" fontWeight="bold">
                Property Details
              </Typography>
              <CloseIcon
                onClick={() => setOpen(false)}
                sx={{ cursor: "pointer" }}
              />
            </Grid>

            <Grid container spacing={1} sx={{ pt: "20px" }}>
              {formFields.map((field, index) => (
                <Grid item xs={12 / field.rowGroup} key={index}>
                  <Typography>{field.label}</Typography>

                  {field.items.length > 0 ? (
                    <TextField
                      select
                      size="small"
                      fullWidth
                      value={searchQuery[field.id] || ""}
                      onChange={(e) =>
                        handleFieldChange(field.id, e.target.value)
                      }
                    >
                      {field.items.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </TextField>
                  ) : (
                    <TextField
                      size="small"
                      fullWidth
                      value={searchQuery[field.id] || ""}
                      onChange={(e) =>
                        handleFieldChange(field.id, e.target.value)
                      }
                    />
                  )}
                </Grid>
              ))}
            </Grid>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Grid2 container justifyContent="center" sx={{ pt: "20px" }}>
                {formCheckBoxes.map((item, index) => (
                  <Grid item xs={4} key={index}>
                    <FormControlLabel
                      sx={{
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "center",
                      }}
                      control={
                        <Checkbox
                          disableRipple
                          checked={checkedItems.includes(index)}
                          onChange={() => handleCheckboxChange(index)}
                        />
                      }
                      label={<span>{item.label}</span>}
                    />
                  </Grid>
                ))}
              </Grid2>
            </Box>

            <Grid container justifyContent="center" sx={{ pt: "20px" }}>
              <Button
                variant="contained"
                onClick={handleSubmit}
                sx={{
                  backgroundColor: theme.palette.primary.main,
                  color: "white",
                  width: "100px",
                  borderRadius: "10px",
                }}
              >
                Find
              </Button>
            </Grid>
          </Box>
        </Fade>
      </Modal>
    </Grid>
  );
};

export default SearchButton;
